import React from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer from '../JustificationContainer';
import { Body } from '../Typography';
import { isProduction } from '~/util';

type StageName = 'dev' | 'prod';

export type Props = {
  excludeStages?: Array<StageName>;
};
/**
 * Only being shown on non-production stages.
 * This is to help FE developers remember which stack/environment
 * they are currently working on during development and testing.
 */
const StageNameBadge: React.FCC<Props> = ({ excludeStages = ['dev'] }) => {
  const isDev = isProduction() !== true;
  const STAGE_NAME = process.env.STAGE_NAME as StageName;

  if (!isDev || !STAGE_NAME) return null;
  if (excludeStages.includes(STAGE_NAME ?? '')) return null;

  return (
    <Container
      backgroundColor={{ group: 'danger', variant: 'light' }}
      padding={['xxs', 'xs']}
      border={{ radius: 'base' }}
      width="max-content"
    >
      <Body
        color={{ group: 'white' }}
        fontWeight="semiBold"
        margin={[null]}
        size="base"
      >
        {STAGE_NAME}
      </Body>
    </Container>
  );
};

const Container = styled(JustificationContainer)(
  ({ theme }) => css`
    position: fixed;
    top: ${theme.space('s')};
    left: ${theme.space('s')};
    right: ${theme.space('s')};
  `,
);

export default StageNameBadge;
